/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Org_Not_Started_BodyInputs */



/**
* | output |
* | --- |
* | "Your organization becomes active on {date}. Your account is ready — sign in again on that day and everything will be waiting for you." |
*
* @param {Org_Not_Started_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_not_started_body = /** @type {((inputs: Org_Not_Started_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Not_Started_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ihre Organisation wird am ${i?.date} aktiv. Ihr Konto ist eingerichtet — melden Sie sich an diesem Tag erneut an, dann steht alles bereit.`)
	return /** @type {LocalizedString} */ (`Your organization becomes active on ${i?.date}. Your account is ready — sign in again on that day and everything will be waiting for you.`)
});